import React, { Component, Suspense } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import Data from "../../data/data";
import PrimaryActionButton from "../../components/PrimaryActionButton";
import { motion } from "framer-motion";
import {
  Card,
  Avatar,
  Button,
  Row,
  Col,
  List,
  Modal,
  Tooltip,
  Space,
  Select,
  Popover,
  Grid,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  SettingOutlined,
  ExclamationCircleOutlined,
  PartitionOutlined,
  DesktopOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
  updateGlobalSearch,
} from "../../actions";
import PopupManager from "../../managers/PopupManager";
import TimelinePage from "../timeline";
import TimelineContentPage from "../timelineContent";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import PermissionManager from "../../managers/PermissionManager";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

import colors from "../../config/Colors";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { USE_CAMPAIGN_SYNC } from "../../Config";
import { LayoutTemplate } from "lucide-react";
import EmptyState from "../../components/EmptyState";
import Animations from "../../animations/Animations";

const { Meta } = Card;
const { confirm } = Modal;

const CampaignPage = (props) => {
  const history = useHistory();
  // Match deep path first, then shallow — lets us extract campaignid and timelineid
  // without remounting CampaignPage when the sub-path changes (single non-exact route).
  const matchDeep = useRouteMatch(
    "/:brandid/:branchid/campaign/:campaignid/:timelineid",
  );
  const matchShallow = useRouteMatch(
    "/:brandid/:branchid/campaign/:campaignid",
  );
  const campaignid =
    matchDeep?.params?.campaignid ?? matchShallow?.params?.campaignid;
  const timelineid = matchDeep?.params?.timelineid;

  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.campaignPage || PRO_TRANSLATIONS.en.campaignPage;
  const screens = Grid.useBreakpoint();
  const isMobile = screens.sm === false;

  return (
    <CampaignPageClass
      preSelectedCampaignID={campaignid}
      preSelectedTimelineID={timelineid}
      history={history}
      langT={t}
      screens={screens}
      isMobile={isMobile}
      {...props}
    ></CampaignPageClass>
  );
};

class CampaignPageClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignDatas: [],
      selectedCampaign: null,
      selectedTimeline: null,
      lastSearch: "",
    };
  }

  componentDidMount() {
    this.updateCampaignListData();
    document.body.classList.add("campaign-no-scrollbar");
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { history, selectedBranchData, selectedBrandData } = this.props;
    const { selectedCampaign, selectedTimeline } = this.state;

    // Sidebar re-click: user clicked Schedule menu while already on this page
    const prevPageId = prevProps.selectedPage?.id;
    const currPageId = this.props.selectedPage?.id;
    if (
      currPageId === Constants.CAMPAIGN_PAGE &&
      prevPageId === Constants.CAMPAIGN_PAGE &&
      prevProps.selectedPage !== this.props.selectedPage &&
      (this.state.selectedCampaign || this.state.selectedTimeline)
    ) {
      this.setState({ selectedCampaign: null, selectedTimeline: null });
      return;
    }

    // Guard: brand/branch data may not yet be restored after a page refresh
    if (!selectedBrandData || !selectedBranchData) {
      if (
        (this.props.selectedBrandData &&
          this.props.selectedBrandData !== prevProps.selectedBrandData) ||
        (this.props.preSelectedCampaignID &&
          this.props.preSelectedCampaignID !== prevProps.preSelectedCampaignID)
      ) {
        this.updateCampaignListData();
      }
      return;
    }

    const base = `/${selectedBrandData.BrandID}/${selectedBranchData.BranchID}/campaign`;

    // Keep URL in sync using replace (never push) so we stay on the same
    // Route instance — no unmount/remount when sub-path changes.
    if (
      selectedTimeline !== prevState.selectedTimeline ||
      selectedCampaign !== prevState.selectedCampaign
    ) {
      let target;
      if (selectedTimeline && selectedCampaign) {
        target = `${base}/${selectedCampaign.CampaignID}/${selectedTimeline.TimelineID}`;
      } else if (selectedCampaign) {
        target = `${base}/${selectedCampaign.CampaignID}`;
      } else {
        target = base;
      }
      if (history.location.pathname !== target) history.replace(target);
    }

    if (
      (this.props.selectedBrandData &&
        this.props.selectedBrandData !== prevProps.selectedBrandData) ||
      (this.props.preSelectedCampaignID &&
        this.props.preSelectedCampaignID !== prevProps.preSelectedCampaignID)
    ) {
      this.updateCampaignListData();
    }
  };

  updateCampaignListData = () => {
    const {
      requestServerGet,
      userdata,
      selectedBrandData,
      preSelectedCampaignID = -1,
    } = this.props;

    console.log(
      "updateCampaignListData preSelectedCampaignID " + preSelectedCampaignID,
    );
    if (!selectedBrandData) return;

    console.log(
      "updateCampaignListData preSelectedCampaignID " + preSelectedCampaignID,
    );

    requestServerGet(
      "get_campaigns",
      { brandid: selectedBrandData.BrandID },
      null,
      (response) => {
        // console.log("get_campagins")
        // console.log(JSON.stringify(response.data))
        // this.setState({ campaignDatas: response.data }, () => {

        //     console.log("this.state.campaignDatas " + this.state.campaignDatas)

        //     if (preSelectedCampaignID > -1) {
        //         const cData = this.state.campaignDatas.find(data => {
        //             console.log(`cData lookin ${data.CampaignID} ${preSelectedCampaignID}`)
        //             return `${data.CampaignID}` === `${preSelectedCampaignID}`
        //         })

        //         if (cData) {
        //             console.log("got selected campaign")
        //             this.setState({ selectedCampaign: cData })
        //         }
        //     }
        // })
        const newState = { campaignDatas: response.data };
        if (preSelectedCampaignID > -1) {
          const cData = response.data.find(
            (data) => `${data.CampaignID}` === `${preSelectedCampaignID}`,
          );
          if (cData) newState.selectedCampaign = cData;
        }
        this.setState(newState, () => {
          if (newState.selectedCampaign) this.updateTimelineListData();
        });
      },
      userdata.token,
    );
  };

  updateTimelineListData = () => {
    const { selectedCampaign } = this.state;
    const {
      requestServerGet,
      userdata,
      selectedBrandData,
      preSelectedTimelineID,
    } = this.props;

    if (!selectedBrandData) return;

    if (!selectedCampaign) return;

    requestServerGet(
      "get_timelines",
      {
        brandid: selectedBrandData.BrandID,
        campaignid: selectedCampaign.CampaignID,
      },
      null,
      (response) => {
        const newState = { timelineDatas: response.data };
        if (preSelectedTimelineID) {
          const tData = response.data.find(
            (t) => `${t.TimelineID}` === `${preSelectedTimelineID}`,
          );
          if (tData) newState.selectedTimeline = tData;
        }
        this.setState(newState);
      },
      userdata.token,
    );
  };

  onCampaignClicked = (data) => {
    const { globalSearch, selectPage, history, selectedBranchData } =
      this.props;
    console.log("onCampaignClicked " + globalSearch);

    console.log("onCampaignClicked data " + JSON.stringify(data));

    history.push(
      `/${data.BrandID}/${selectedBranchData.BranchID}/campaign/${data.CampaignID}`,
    );
    // selectPage(Constants.CAMPAIGN_PAGE, {id: data.CampaignID})
    // this.setState({ selectedCampaign: data, lastSearch: globalSearch }, () => {
    //     this.updateTimelineListData();
    // })
  };

  onCampaignContentClicked = (data) => {
    // console.log("onCampaignContentClicked")
    this.setState({ selectedTimeline: data });
  };

  onBackOffCampaignContent = () => {
    console.log("onBackOffCampaignContent");
    this.setState({ selectedCampaign: null });
  };
  onBackOffCampaignContentChannel = () => {
    this.setState({ selectedTimeline: null });
  };

  showConfirm = (data, callback) => {
    const { selectPage, globalSearch, usertoken, requestServerPost } =
      this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.campaignPage;

    confirm({
      title: t.deleteConfirm,
      icon: <ExclamationCircleOutlined />,
      centered: true,
      maskClosable: true,
      onOk() {
        requestServerPost(
          "delete_campaign",
          { campaignid: data.CampaignID },
          {},
          () => {
            callback();
          },
          usertoken,
        );
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  launchCreateCampaign = () => {
    PopupManager.launchCreateCampaignPopup(this.updateCampaignListData);
  };
  launchDuplicateCampaign = (data) => {
    PopupManager.launchDuplicateCampaignPopup(
      data,
      this.updateCampaignListData,
    );
  };
  launchEditCampaign = (data) => {
    PopupManager.launchEditCampaignPopup(data, this.updateCampaignListData);
  };

  renderCampaignList = () => {
    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );
    const deletePermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_DELETE,
    );
    const t = this.props.langT || PRO_TRANSLATIONS.en.campaignPage;
    const isMobile = this.props.isMobile;

    if (this.state.campaignDatas.length === 0)
      return (
        <EmptyState
          icon={<LayoutTemplate size={28} color="#6366f1" />}
          title={t.emptyTitle}
          description={t.emptyDesc}
        />
      );

    const { requestServerGet, userdata, selectedBrandData, globalSearch } =
      this.props;
    const filteredList = this.state.campaignDatas
      .filter((data) => {
        return data.CampaignName.toLocaleLowerCase().includes(
          globalSearch.toLocaleLowerCase(),
        );
      })
      .sort((a, b) => {
        return a.CampaignName.toLocaleLowerCase() >
          b.CampaignName.toLocaleLowerCase()
          ? 1
          : -1;
      });

    return filteredList.map((data) => {
      const firstLetter =
        data.CampaignName.length > 0 ? data.CampaignName.charAt(0) : "";
      return (
        <motion.div
          key={`${data.CampaignID}${data.CampaignName}`}
          variants={Animations.LIST_ITEM}
          style={{
            width: isMobile ? "calc(50% - 6px)" : 220,
            flexShrink: 0,
          }}
        >
          <LazyLoadComponent>
            <Suspense fallback={null}>
              <motion.div style={{ width: "100%" }}>
                <Card
                  key={data.CampaignID}
                  size={isMobile ? "small" : "default"}
                  style={{ textAlign: "left", width: "100%" }}
                  cover={
                    <div>
                      {USE_CAMPAIGN_SYNC && (
                        <Tooltip
                          title={`CampaignSync | ${data.CampaignSync ? t.syncOn : t.syncOff}`}
                        >
                          <Button
                            danger={data.CampaignSync}
                            type={data.CampaignSync ? "primary" : "dashed"}
                            shape="circle"
                            size={isMobile ? "small" : "large"}
                            icon={
                              data.CampaignSync ? (
                                <PartitionOutlined />
                              ) : (
                                <DesktopOutlined />
                              )
                            }
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                            }}
                            onClick={() => {
                              this.updateCampaignSync(
                                data.CampaignID,
                                !data.CampaignSync,
                              );
                            }}
                          ></Button>
                        </Tooltip>
                      )}
                      <div
                        onClick={() => this.onCampaignClicked(data)}
                        style={{
                          fontFamily: "Kanit",
                          backgroundColor: data.CampaignColor
                            ? data.CampaignColor
                            : colors.blue,
                          display: "flex",
                          fontSize: isMobile ? "32px" : "60px",
                          fontWeight: 600,
                          width: "100%",
                          height: isMobile ? "70px" : "120px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {firstLetter.toLocaleUpperCase()}
                      </div>
                    </div>
                  }
                  actions={[
                    editPermission ? (
                      <Tooltip title={t.tooltipEdit}>
                        <EditOutlined
                          key="edit"
                          onClick={() => this.launchEditCampaign(data)}
                        />
                      </Tooltip>
                    ) : null,
                    editPermission ? (
                      <Tooltip title={t.tooltipDuplicate}>
                        <CopyOutlined
                          key="duplicate"
                          onClick={() => this.launchDuplicateCampaign(data)}
                        />
                      </Tooltip>
                    ) : null,
                    deletePermission ? (
                      <Tooltip title={t.tooltipDelete}>
                        <DeleteOutlined
                          key="delete"
                          onClick={() => {
                            this.showConfirm(data, this.updateCampaignListData);
                          }}
                        />
                      </Tooltip>
                    ) : null,
                  ].filter((a) => a !== null)}
                >
                  <Meta
                    avatar={
                      <Avatar
                        style={{ width: "28px", height: "28px" }}
                        shape="square"
                        src="/cms/assets/svgs/campaign_icon_dark.svg"
                      />
                    }
                    title={data.CampaignName}
                    description={selectedBrandData.BrandName}
                  />
                </Card>
              </motion.div>
            </Suspense>
          </LazyLoadComponent>
        </motion.div>
      );
    });
  };

  onTimelineSelected = (timelineData) => {
    this.setState({ selectedTimeline: timelineData });
  };

  localStepBack = (destination) => {
    const { selectedBranchData, selectedBrandData, history } = this.props;
    console.log("local step back");
    switch (destination) {
      case "campaign":
        console.log("localStepBack campaign");

        this.setState({ selectedTimeline: null, selectedCampaign: null });
        break;
      case "timeline":
        console.log("localStepBack timeline");
        this.setState({ selectedTimeline: null });
        break;
    }
  };

  getTimelineContentView = () => {
    const { selectPage } = this.props;
    return (
      <TimelineContentPage
        localStepBack={this.localStepBack}
        onBackClicked={() => {
          this.setState({ selectedTimeline: null }, () => {});
        }}
        preventDefaultStepBack={true}
        selectedCampaign={this.state.selectedCampaign}
        selectedTimeline={this.state.selectedTimeline}
      ></TimelineContentPage>
    );
  };
  getCampaignContentView = () => {
    const { updateGlobalSearch, selectedPage, selectPage } = this.props;
    const fromPage =
      selectedPage && selectedPage.content && selectedPage.content.fromPage;
    return (
      <TimelinePage
        localStepBack={this.localStepBack}
        onBackClicked={() => {
          if (fromPage) {
            selectPage(fromPage, null, false);
          } else {
            this.setState({ selectedCampaign: null }, () => {
              setTimeout(() => {
                console.log(
                  "updateGlobalSearch(this.state.lastSearch) " +
                    this.state.lastSearch,
                );
                updateGlobalSearch(this.state.lastSearch);
              }, 200);
            });
          }
        }}
        preventDefaultStepBack={true}
        onTimelineSelected={this.onTimelineSelected}
        selectedCampaign={this.state.selectedCampaign}
      ></TimelinePage>
    );
  };
  getCampaignView = () => {
    const createPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const t = this.props.langT || PRO_TRANSLATIONS.en.campaignPage;
    const isMobile = this.props.isMobile;
    return (
      <MainLayout
        id={Constants.CAMPAIGN_PAGE}
        style={{ padding: 20 }}
        renderBreadCrumb={() => {
          return [
            <span
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: "#94a3b8",
                padding: "4px 8px",
                lineHeight: "22px",
              }}
            >
              {t.title}
            </span>,
          ];
        }}
      >
        {/* Page header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: isMobile ? "wrap" : "nowrap",
            gap: isMobile ? 12 : 8,
            background: "#fff",
            borderRadius: 16,
            padding: isMobile ? "16px" : "20px 24px",
            border: "1px solid #e8ecf3",
            marginBottom: 20,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              flex: isMobile ? "1 1 100%" : 1,
              minWidth: 0,
            }}
          >
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                flexShrink: 0,
                background: "linear-gradient(135deg, #eef2ff, #e0e7ff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LayoutTemplate size={26} color="#6366f1" />
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: "#0f172a",
                  lineHeight: 1.2,
                }}
              >
                {t.title}
              </div>
              <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 3 }}>
                {t.subtitle}
              </div>
            </div>
          </div>
          {createPermission ? (
            <PrimaryActionButton
              onClick={this.launchCreateCampaign}
              style={isMobile ? { width: "100%" } : undefined}
            >
              {t.createCampaign}
            </PrimaryActionButton>
          ) : null}
        </div>

        <motion.div
          variants={Animations.LIST_CONTAINER}
          initial="hidden"
          animate="show"
          key={this.state.campaignDatas.length > 0 ? "loaded" : "empty"}
          style={{
            overflowY: "hidden",
            flexWrap: "wrap",
            justifyContent: this.props.isMobile ? "space-between" : "center",
            gap: this.props.isMobile ? "12px" : "15px",
            display: "flex",
            overflowX: "hidden",
            width: "100%",
          }}
        >
          {this.renderCampaignList()}
        </motion.div>
      </MainLayout>
    );
  };

  componentWillUnmount() {
    console.log("UNMOUNTNIG CAMPAIGN");
    document.body.classList.remove("campaign-no-scrollbar");
  }
  updateCampaignSync = (campaignID, newSync) => {
    const { usertoken, requestServerPost } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.campaignPage;
    var params = new FormData();
    params.append("campaignid", campaignID);
    params.append("campaignsync", newSync);

    console.log("updateCampaignSync " + JSON.stringify(params));
    const self = this;
    if (newSync) {
      confirm({
        title: t.syncConfirm,
        icon: <ExclamationCircleOutlined />,
        onOk() {
          requestServerPost(
            "update_campaign",
            params,
            {},
            (response) => {
              self.updateCampaignListData();
            },
            usertoken,
          );
        },
        onCancel() {
          // console.log('Cancel');
        },
      });
    } else {
      requestServerPost(
        "update_campaign",
        params,
        {},
        (response) => {
          self.updateCampaignListData();
        },
        usertoken,
      );
    }
  };

  render() {
    console.log("[Campaign ]render");
    const data = Data.MOCK_CAMPAIGNS;
    console.log("[Campaign ]got campaignview");
    var view = this.getCampaignView();
    if (this.state.selectedTimeline !== null) {
      console.log("[Campaign ]got TimelineContentView");
      view = this.getTimelineContentView();
    } else if (this.state.selectedCampaign !== null) {
      console.log("[Campaign ]got CampaignContentView");
      view = this.getCampaignContentView();
    }

    return view;
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBranchData: state.selectedBranchData,
    selectedBrandData: state.selectedBrandData,
    selectedPage: state.selectedPage,
  };
};

export default connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  updateGlobalSearch,
  selectPage,
})(CampaignPage);
